import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { format, parseISO } from 'date-fns';
import { Box } from '@daedalus/atlas/helpers/Box';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { getError, getFreezeSelectedContext } from '../../modules/selector';
import { ErrorButton } from './ErrorButton';
import { useGetErrorMessageAndCase } from './useGetErrorMessageAndCase';
import { useTrackApiError } from './useTrackApiError';
const formatDate = (date: string) => {
  return format(parseISO(date), 'MMM dd');
};
const _exp = /*#__PURE__*/() => ContentWrapper;
const Container = /*#__PURE__*/styled(_exp())({
  name: "Container",
  class: "c18rjk25",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => Icon;
const StyledIcon = /*#__PURE__*/styled(_exp3())({
  name: "StyledIcon",
  class: "s1980ivl",
  propsAsIs: true
});
export const ErrorMessage: React.FC = () => {
  const {
    formatMessage
  } = useIntl();
  const {
    searchDetail
  } = useSelector(getFreezeSelectedContext);
  const {
    checkIn,
    checkOut
  } = searchDetail || {};
  const error = useSelector(getError);
  const {
    errored
  } = error || {};
  const {
    message,
    icon,
    errorCase,
    description,
    ctaText
  } = useGetErrorMessageAndCase({
    error
  });

  // when errorMessage component is shown with all the required data, error should be tracked
  useTrackApiError({
    error,
    errorCase
  });
  if (!errored) return null;
  const checkInDate = checkIn && formatDate(checkIn);
  const checkOutDate = checkOut && formatDate(checkOut);
  const formattedMessage = formatMessage(message, {
    checkIn: checkInDate,
    checkOut: checkOutDate
  });
  return <Container padding="s500">
      <Box display="flex" flexDirection="column" gap="s200" alignItems="flex-start" marginBottom="s400">
        <Box display="flex" gap="s100" alignItems="center">
          <StyledIcon name={icon} />
          <Text variant="titleM">{formattedMessage}</Text>
        </Box>
        {description && <Text variant="bodyS">
            {formatMessage(description as MessageDescriptor)}
          </Text>}
      </Box>
      <ErrorButton ctaText={ctaText} errorCase={errorCase} />
    </Container>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");